"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm$data$punchIn, _vm$data$punchIn2, _vm$data$punchOut, _vm$data$punchOut2;
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    attrs: {
      active: _vm.isModalActive,
      width: 640,
      scroll: "keep"
    },
    on: {
      close: function close($event) {
        return _vm.$emit("onClose");
      }
    }
  }, [_c("form", {
    on: {
      submit: function submit($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments);
      }
    }
  }, [_c("div", {
    staticClass: "modal-card"
  }, [_c("header", {
    staticClass: "modal-card-head"
  }, [_c("p", {
    staticClass: "modal-card-title"
  }, [_vm._v("\n          Detalhes da Marcação\n        ")]), _vm._v(" "), _c("button", {
    staticClass: "delete",
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        return _vm.$emit("onClose");
      }
    }
  })]), _vm._v(" "), _c("section", {
    staticClass: "modal-card-body"
  }, [_c("b-field", {
    attrs: {
      label: "Funcionário"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.data.user.firstName) + " " + _vm._s(_vm.data.user.lastName) + " - " + _vm._s(_vm.data.user.email) + "\n        ")]), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Tempo Trabalhado"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formatSeconds(_vm.data.workedSeconds)) + "\n        ")]), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Horário de entrada"
    }
  }, [_vm._v("\n          Submetido: " + _vm._s(_vm.formatTime((_vm$data$punchIn = _vm.data.punchIn) === null || _vm$data$punchIn === void 0 ? void 0 : _vm$data$punchIn.originalSubmittedTime)) + " "), _c("br"), _vm._v("\n          Editado: " + _vm._s(_vm.formatTime((_vm$data$punchIn2 = _vm.data.punchIn) === null || _vm$data$punchIn2 === void 0 ? void 0 : _vm$data$punchIn2.clockedAt)) + "\n        ")]), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Horário de saída"
    }
  }, [_vm._v("\n          Submetido: " + _vm._s(_vm.formatTime((_vm$data$punchOut = _vm.data.punchOut) === null || _vm$data$punchOut === void 0 ? void 0 : _vm$data$punchOut.originalSubmittedTime)) + " "), _c("br"), _vm._v("\n          Editado: " + _vm._s(_vm.formatTime((_vm$data$punchOut2 = _vm.data.punchOut) === null || _vm$data$punchOut2 === void 0 ? void 0 : _vm$data$punchOut2.clockedAt)) + "\n        ")]), _vm._v(" "), _c("hr"), _vm._v(" "), _c("div", {
    staticClass: "edit-fields"
  }, [_c("b-field", {
    attrs: {
      label: "Editar horário de entrada"
    }
  }, [_c("b-timepicker", {
    attrs: {
      placeholder: "Selecione o horário de entrada",
      "hour-format": "24",
      "increment-minutes": 5
    },
    model: {
      value: _vm.form.editPunchInTime,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "editPunchInTime", $$v);
      },
      expression: "form.editPunchInTime"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Editar horário de saída"
    }
  }, [_c("b-timepicker", {
    attrs: {
      placeholder: "Selecione o horário de saída",
      "hour-format": "24",
      "increment-minutes": 5
    },
    model: {
      value: _vm.form.editPunchOutTime,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "editPunchOutTime", $$v);
      },
      expression: "form.editPunchOutTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c("footer", {
    staticClass: "modal-card-foot"
  }, [_c("b-button", {
    staticClass: "btn",
    attrs: {
      type: "is-primary",
      "native-type": "submit"
    }
  }, [_vm._v("\n          Salvar\n        ")]), _vm._v(" "), _c("b-button", {
    on: {
      click: function click($event) {
        return _vm.$emit("onClose");
      }
    }
  }, [_vm._v("\n          Cancelar\n        ")])], 1)])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;